import api from "@/app/services/api";

export type FormCodeEntry = {
  subType: string;
  formCode: string;
};

export function extractErrorMessage(error: unknown, fallback: string) {
  const err = error as { response?: { data?: { message?: string } }; message?: string };
  return err.response?.data?.message || err.message || fallback;
}

export async function fetchFormCodes(): Promise<FormCodeEntry[]> {
  const response = await api.get("/integration/api/nir/form-codes");
  const data = (response.data?.data ?? response.data) as Record<string, string>;

  return Object.keys(data || {}).map((key) => ({
    subType: key,
    formCode: data[key],
  }));
}

export async function saveFormCode(payload: { subType: string; formCode: string }) {
  return api.post("/integration/api/nir/form-codes", payload);
}

export function formatSlugLabel(value: string) {
  return value
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
